import { type QueryKey, useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useNavigateBackOrDefault } from "web_myplann/Shared/Hooks/useNavigateBackOrDefault";

type UseNotFoundRedirectParams = {
	isNotFound: boolean;
	message: string;
	defaultRoute: string;
	invalidateQueryKeys?: QueryKey[];
};

export const useNotFoundRedirect = ({
	isNotFound,
	message,
	defaultRoute,
	invalidateQueryKeys,
}: UseNotFoundRedirectParams) => {
	const queryClient = useQueryClient();
	const navigateBackOrDefault = useNavigateBackOrDefault(defaultRoute, {
		replaceOnBack: true,
	});
	const handledRef = useRef(false);

	useEffect(() => {
		if (!isNotFound) {
			handledRef.current = false;
			return;
		}
		if (handledRef.current) return;
		handledRef.current = true;

		toast.error(message, { id: message });
		for (const queryKey of invalidateQueryKeys ?? []) {
			queryClient.invalidateQueries({ queryKey });
		}
		navigateBackOrDefault();
	}, [
		isNotFound,
		message,
		invalidateQueryKeys,
		queryClient,
		navigateBackOrDefault,
	]);
};
